export default __webpack_public_path__ + "static/media/error-mic.ca7a7ca1.svg";